export default "__VITE_ASSET__f62dd390__"